import React from 'react';
import PropTypes from 'prop-types';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import UploadCloudIcon from "../../../svgIcons/UploadCloudIcon";

const UploadFile = ({ itemsColor, onSelectFileClick }) => (
  <div className="data-file-upload__container">
    <UploadCloudIcon color={ itemsColor } style={ { height: 135, width: 135 } } viewBox="0 0 24 24" />
    <div className="data-file-upload__right-section">
      <p>Drag-and-drop</p>
      <p>Data File</p>
      <SovosRaisedButton
        onClick={ onSelectFileClick }
        color="secondary"
      >
        CHOOSE FILE
      </SovosRaisedButton>
    </div>
  </div>
);

UploadFile.propTypes = {
  itemsColor: PropTypes.string,
  onSelectFileClick: PropTypes.func.isRequired
};

UploadFile.defaultProps = {
  itemsColor: '#000'
};

export default UploadFile;



// WEBPACK FOOTER //
// ./src/shared/components/fileDrop/c/uploadFiles/UploadFiles.js